import { GetterTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { FileDetails } from '@/interfaces/files';
import store from '@/store';

const getters: GetterTree<FileDetails, StateInterface> = {
    // someGetter( /* state */ ) {
    //     // return true;
    // },
    // projectId(state) {
    //     return state.projectId;
    // },
    // getEntriesByTerm ( state ) => ( term = '' ) => {

    //     if ( term.length === 0 ) return state.projects
    
    //     return state.entries.filter( entry => entry.text.toLowerCase().includes( term.toLocaleLowerCase() ) )
    // }
    getFileId( state ) {
        return state.fileId;
    },
    getNombre( state ) {
        return state.nombre;
    },
    getClasificacion( state ) {
        return state.clasificacion;
    },
    getResultado( state ) {
        return state.resultado;
    },
    getRevision( state ) {
        return state.revision;
    },
    getLC( state ) {
        return state.LC;
    },
    getEstado( state ) {
        return state.estado;
    },
    getRevisado( state ) {
        return state.revisado;
    },
    getDeletedFile( state ) {
        return state.deletedFile;
    },
    getDocuments( state ) {
        return state.documents;
    },
    getIsDocumentViewerOpen( state ) {
        return state.fileId !== 0;
    },
    getCurrentFile( state ) {
        const documentFile = {
            fileId: store.getters["fileDetails/getFileId"],
            nombre: store.getters["fileDetails/getNombre"],
            clasificacion: store.getters["fileDetails/getClasificacion"],
            resultado: store.getters["fileDetails/getResultado"],
            revision: store.getters["fileDetails/getRevision"],
            estado: store.getters["fileDetails/getEstado"],
            revisado: store.getters["fileDetails/getRevisado"],
            
        };
        return documentFile;
    },
    getReloadFileList( state ) {
        return state.reloadFileList;
    },
    getMovingFile( state ) {
        return state.movingFile;
    },
    getStartTime( state ){
        return state.startTime;
    },
    getDetectedErrors( state ){
        return state.detectedErrors;
    },
    getPaginationData( state ) {
        return state.paginationData;
    },
}



export default getters;